import { render } from "./ProjectSection.vue?vue&type=template&id=b111b8ea&scoped=true"
import script from "./ProjectSection.vue?vue&type=script&lang=js"
export * from "./ProjectSection.vue?vue&type=script&lang=js"

import "./ProjectSection.vue?vue&type=style&index=0&id=b111b8ea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b111b8ea"]])

export default __exports__